import { render, staticRenderFns } from "./dopp.vue?vue&type=template&id=063b15e3&scoped=true"
import script from "./dopp.vue?vue&type=script&lang=js"
export * from "./dopp.vue?vue&type=script&lang=js"
import style0 from "./dopp.vue?vue&type=style&index=0&id=063b15e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063b15e3",
  null
  
)

export default component.exports